import './WhatsNewFilterElementsComponent.scss';
import { FilterVM } from '../../../../common/view-model';
import { FC } from 'react';
import { CheckboxComponent } from '../../../UI/CheckboxComponent/CheckboxComponent';
import { isCurrentUserAnonymous } from '../../../../helpers/authenticationHelper';

interface IFilterElementComponentProps {
	filter: FilterVM;
	selectedFilters?: FilterVM[];
	setLockModalContent: () => void;
	registerUserClickEvent: (event: string) => void;
	pendingFilters?: FilterVM[];
	setPendingFilters?: React.Dispatch<React.SetStateAction<FilterVM[]>>;
	isMobile?: boolean;
}
const FilterElementComponent: FC<IFilterElementComponentProps> = ({
	filter,
	selectedFilters,
	setLockModalContent,
	registerUserClickEvent,
	pendingFilters,
	setPendingFilters,
	isMobile
}) => {
	return (
		<div className='whats-new-filter-content'>
			<CheckboxComponent
				checked={
					selectedFilters?.find(selectedFilter => selectedFilter.id === filter.id) !== undefined
				}
				label={filter.name}
				children={filter.children}
				type={filter.type}
				parentLength={0}
				style='primary'
				isLocked={isCurrentUserAnonymous()}
				setLockModalContent={setLockModalContent}
				registerUserClickEvent={registerUserClickEvent}
				parentIndex={filter.id}
				pendingFilters={pendingFilters}
				setPendingFilters={setPendingFilters}
				isNewFilter={true}
				toolTipText={filter.toolTip ? <>{filter.toolTip.description}</> : undefined}
			/>
		</div>
	);
};

interface IWhatsNewFilterElementsComponentProps {
	filters: FilterVM[];
	currentCategory: string;
	setCurrentCategory: (category?: string) => void;
	productsPageUrl: string;
	selectedFilters?: FilterVM[];
	setLockModalContent: () => void;
	registerUserClickEvent: (event: string) => void;
	clearAllFilters: () => void;
	pendingFilters?: FilterVM[];
	setPendingFilters?: React.Dispatch<React.SetStateAction<FilterVM[]>>;
	isMobile?: boolean;
}

export const WhatsNewFilterElementsComponent: FC<IWhatsNewFilterElementsComponentProps> = ({
	filters,
	currentCategory,
	setCurrentCategory,
	productsPageUrl,
	selectedFilters,
	setLockModalContent,
	registerUserClickEvent,
	clearAllFilters,
	isMobile,
	pendingFilters,
	setPendingFilters
}) => {
	console.log('filters', filters);
	return (
		<div className='whats-new-container'>
			<div className='filter-elements'>
				{filters?.map(filter => (
					<FilterElementComponent
						filter={filter}
						key={filter.id}
						selectedFilters={selectedFilters}
						setLockModalContent={setLockModalContent}
						registerUserClickEvent={registerUserClickEvent}
						pendingFilters={pendingFilters}
						setPendingFilters={setPendingFilters}
						isMobile={isMobile}
					/>
				))}
			</div>
		</div>
	);
};
